<template>
  <page style="position: relative">
    <metabase-application />
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import MetabaseApplication from './MetabaseApplication'

export default {
  name: 'MetabasePage',

  components: {
    MetabaseApplication,
    Page
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/metabase/pages/MetabasePage.vue